import { FC, HTMLAttributes } from "react";
import { ReactComponent as HelpIcon } from "src/Themes/assets/question.svg";
import st from "./HelpHint.module.scss";

interface IHelpHintProps extends HTMLAttributes<HTMLSpanElement> {
	disable?: boolean;
	variant?: "white" | "gray";
};

const HelpHint: FC<IHelpHintProps> = ( { title, variant = "gray", disable = false, ...otherProps } ) => {

	const getTtId = () => {
		if ( !title || disable ) return '';
		else if ( variant === "gray" ) return 'rdc_tooltip';
		else if ( variant === "white" ) return "rdc_tooltip";
	};

	return (
		<span {...otherProps}>
			<HelpIcon
				className={st.hintIcon}
				data-tooltip-id={getTtId()} 
				data-tooltip-content={ title } 
			/>
		</span>
	);
};

export default HelpHint;
